<template>
  <modal
    name="edit-customer-modal"
    :height="isMobile ? '100%' : 'auto'"
    :width="isMobile ? '100%' : '40%'"
    :scrollable="true"
    @opened="getDetail()"
    @closed="resetForm()"
  >
    <logModule :moduleId="4" :rowId="row.id" />
    <!-- Header -->
    <div
      class="pt-3 pb-2 pr-4 pl-4 border-gray-100 dark:border-gray-500 dark:bg-gray-900 dark:text-gray-200 w-full flex items-center justify-center"
    >
      <h4 class="inline-block w-10/12">
        {{ $t("operations.customers.modal.editCustomer") }}
      </h4>
      <div class="mt-4 w-2/12 ml-auto flex items-center">
        <div class="w-6/12">
          <logBtn />
        </div>
        <div class="w-6/12">
          <button class="" @click="$modal.hide('edit-customer-modal')">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Header -->

    <!-- Body -->

    <form
      class="p-4 bg-white dark:bg-gray-900 text-black dark:text-gray-200 border-gray-200 border-b border-t border-opacity-30 overflow-y-auto h-full pb-20 xl:h-auto xl:pb-3"
    >
      <!-- İlk satır: Müşteri adı ve Öncelik -->
      <div class="flex gap-4">
        <div class="flex-1">
          <diffInput
            :title="$t('operations.customers.modal.customerName')"
            v-model="name"
            maxlength="500"
            minlength="2"
            required
            type="Text"
          />
        </div>
        <div class="w-32">
          <diffInput
            title="Öncelik"
            v-model="priorty"
            :min="1"
            :max="10"
            required
            type="number"
            :step="1"
          />
        </div>
      </div>

      <!-- İkinci satır: Hassasiyet ve Boşaltma noktası -->
      <div class="flex gap-4 mt-4">
        <div class="flex-1">
          <diffInput
            title="Hassasiyet (metre)"
            v-model="sensibility"
            min="10"
            max="20000"
            required
            type="number"
            :step="1"
          />
        </div>
        <div class="flex-1">
          <diffInput
            title="Boşaltma Noktası Sayısı"
            v-model="unloadingPointCount"
            min="1"
            max="100"
            required
            type="number"
            :step="1"
          />
        </div>
      </div>

      <div class="mt-4">
        <diffInput
          title="Zorunlu Yıkatma Durumu"
          v-model="requiredWashingStatus"
          required
          type="select"
          :optList="[
            {
              id: '2',
              name: 'Hayır',
            },
            {
              id: '1',
              name: 'Evet',
            },
          ]"
        />
      </div>

      <div class="mt-4">
        <GmapItem
          placeHolder="Konum | Adres"
          height="200px"
          @change="(val) => (position = val)"
          :draggable="true"
          :lat="position.lat"
          :lng="position.lng"
          :defaultAdress="position.adress"
        />
      </div>

      <div class="mt-4">
        <workDays v-model="workDayList" :isEdit="true" />
      </div>

      <div class="mt-4">
        <rejectedLoadsSelector
          v-model="rejectedLoads"
          :key="rejectedLoadsKey"
        />
      </div>

      <div class="w-full mt-4 text-right">
        <asyncBtn
          :type="'button'"
          icon="fas fa-check"
          :text="$t('general.saveButtonTitle')"
          :loadTitle="$t('general.saveButtonLoadTitle')"
          :loadState="load"
          class="w-full"
          @click="save"
        />
      </div>
    </form>
    <!-- Body -->
  </modal>
</template>

<script>
//Global Components
import diffInput from "@/components/general/diffInput.vue";
import asyncBtn from "@/components/general/asyncBtn.vue";
import GmapItem from "@/components/general/gmapInput.vue";
import logModule from "@/components/modals/logModule/index.vue";
import logBtn from "@/components/modals/logModule/logBtn.vue";

//Local Components
import workDays from "./workDays.vue";
import rejectedLoadsSelector from "./rejectedLoadsSelector.vue";

// networking
import axios from "axios";
import { customer } from "@/networking/urlmanager";
export default {
  name: "edit-customer-modal",
  props: ["row"],
  components: {
    diffInput,
    asyncBtn,
    logModule,
    GmapItem,
    logBtn,
    workDays,
    rejectedLoadsSelector,
  },
  data() {
    return {
      name: "",
      priorty: 1,
      sensibility: 0,
      unloadingPointCount: 0,
      requiredWashingStatus: 2,
      position: {
        lat: 0,
        lng: 0,
        adress: "",
      },
      load: false,
      workDayList: [],
      rejectedLoads: [],
      rejectedLoadsKey: 0,
    };
  },
  methods: {
    async getDetail() {
      console.log('Edit modal getDetail - row data:', this.row);

      // API'den müşteri detayını çek
      try {
        const response = await axios.get(
          customer.getAll + "?customerId=" + this.row.id,
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.userData.token,
            },
          }
        );

        console.log('Customer detail API response:', response.data);

        let customerData = this.row;

        // API'den gelen veriyi kullan (eğer başarılı ise)
        if (response.data.code === 200 && response.data.data.detail && response.data.data.detail.length > 0) {
          customerData = response.data.data.detail[0];
          console.log('Using API customer data:', customerData);
        } else {
          console.log('Using passed row data');
        }

        // Load basic customer details
        this.name = customerData.name || '';
        this.priorty = customerData.priority || 1;
        this.sensibility = customerData.sensibility || 0;
        this.requiredWashingStatus = customerData.requiredWashingStatus || 2;
        this.unloadingPointCount = customerData.unloadingPointCount || 0;
        this.position = {
          adress: customerData?.address || '',
          lat: Number(customerData?.latitude) || 0,
          lng: Number(customerData?.longitude) || 0,
        };

        // shiftHours kontrolü - JSON string olarak gelebilir
        let shiftHours = customerData.shiftHours || [];

        // Eğer string ise parse et
        if (typeof shiftHours === 'string') {
          try {
            shiftHours = JSON.parse(shiftHours);
          } catch (e) {
            console.error('shiftHours parse error:', e);
            shiftHours = [];
          }
        }

        // Array değilse veya boşsa default değer ata
        if (!Array.isArray(shiftHours)) {
          shiftHours = [];
        }

        // NULL değerleri filtrele
        shiftHours = shiftHours.filter(item => item !== null && item !== undefined);

        console.log('Processed shiftHours:', shiftHours);

        // rejected_loads kontrolü - JSON string olarak gelebilir
        let rejectedLoads = customerData.rejected_loads || [];
        console.log('Raw rejected_loads from API:', rejectedLoads, 'type:', typeof rejectedLoads);

        // Eğer string ise parse et
        if (typeof rejectedLoads === 'string') {
          try {
            rejectedLoads = JSON.parse(rejectedLoads);
            console.log('After parsing:', rejectedLoads);
          } catch (e) {
            console.error('rejected_loads parse error:', e);
            rejectedLoads = [];
          }
        }

        // Array değilse veya boşsa default değer ata
        if (!Array.isArray(rejectedLoads)) {
          console.warn('rejectedLoads is not an array, setting to empty:', rejectedLoads);
          rejectedLoads = [];
        }

        // NULL değerleri filtrele
        rejectedLoads = rejectedLoads.filter(item => item !== null && item !== undefined && item !== '');

        console.log('Final processed rejectedLoads to be set:', rejectedLoads);

        this.rejectedLoads = rejectedLoads;
        console.log('this.rejectedLoads after assignment:', this.rejectedLoads);

        // Force component re-render
        this.rejectedLoadsKey++;

        this.workDayList = shiftHours.map((item) => ({
          ...item,
          status: 1,
          day:
            item.dayId === 1
              ? "Pazartesi"
              : item.dayId === 2
              ? "Salı"
              : item.dayId === 3
              ? "Çarşamba"
              : item.dayId === 4
              ? "Perşembe"
              : item.dayId === 5
              ? "Cuma"
              : item.dayId === 6
              ? "Cumartesi"
              : item.dayId === 7
              ? "Pazar"
              : "",
        }));

      } catch (error) {
        console.error('Error fetching customer detail:', error);
        // Hata durumunda row datasını kullan
        this.name = this.row.name || '';
        this.priorty = this.row.priority || 1;
        this.sensibility = this.row.sensibility || 0;
        this.requiredWashingStatus = this.row.requiredWashingStatus || 2;
        this.unloadingPointCount = this.row.unloadingPointCount || 0;
        this.position = {
          adress: this.row?.address || '',
          lat: Number(this.row?.latitude) || 0,
          lng: Number(this.row?.longitude) || 0,
        };
        this.workDayList = [];
        this.rejectedLoads = [];
      }
    },
    save() {
      if(this.isEmptyText(this.name)) {
        this.swalBox(
            "warning",
            this.$t("general.warningTitle"),
            "Lütfen müşteri ismini eksiksiz olarak doldurun!",
            false,
            this.$t("general.OkayTitle")
          )
          return;
      }

      if (this.position.adress?.length == 0|| this.position.lat === 0 || this.position.lng === 0) {
        this.swalBox(
          "warning",
          this.$t("general.warningTitle"),
          "Lütfen müşteri adresini eksiksiz olarak doldurun!",
          false,
          this.$t("general.OkayTitle")
        );
        return;
      }

      this.load = true;
      axios
        .post(
          customer.edit,
          {
            rowId: this.row.id,
            name: this.name,
            priorty: this.priorty,
            sensibility: this.sensibility,
            address: this.position.adress,
            latitude: this.position.lat,
            longitude: this.position.lng,
            requiredWashingStatus: this.requiredWashingStatus,
            unloadingPointCount: this.unloadingPointCount,
            shiftHours: this.workDayList,
            rejectedLoads: this.rejectedLoads,
          },
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.userData.token,
            },
          }
        )
        .then(async () => {
          this.swalBox(
            "success",
            this.$t("general.successTitle"),
            "",
            false,
            this.$t("general.OkayTitle")
          ).then(() => {
            this.name = "";
            this.priorty = "1";
            this.sensibility = "";
            this.unloadingPointCount = "";
            this.requiredWashingStatus = "2";
            this.load = false;

            this.$emit("refresh", true);
            this.$modal.hide("edit-customer-modal");
          });
        })
        .catch((err) => {
          this.load = false;
          this.errorBox(err.response);
        });
    },

    resetForm() {
      this.name = "";
      this.priorty = 1;
      this.sensibility = 0;
      this.unloadingPointCount = 0;
      this.requiredWashingStatus = 2;
      this.position = {
        lat: 0,
        lng: 0,
        adress: "",
      };
      this.workDayList = [];
      this.rejectedLoads = [];
      this.rejectedLoadsKey++;
    },
  },
};
</script>
